import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Ellipsis = function Ellipsis(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42969 12.1631C7.42969 10.9941 6.54199 10.1064 5.36426 10.1064C4.23926 10.1064 3.30762 11.0205 3.30762 12.1631C3.30762 13.2705 4.23926 14.2197 5.36426 14.2197C6.48047 14.2197 7.42969 13.2705 7.42969 12.1631ZM14.0566 12.1631C14.0566 10.9941 13.1689 10.1064 12 10.1064C10.875 10.1064 9.94336 11.0205 9.94336 12.1631C9.94336 13.2705 10.875 14.2197 12 14.2197C13.1074 14.2197 14.0566 13.2705 14.0566 12.1631ZM20.6924 12.1631C20.6924 10.9941 19.8047 10.1064 18.6357 10.1064C17.502 10.1064 16.5703 11.0205 16.5703 12.1631C16.5703 13.2705 17.502 14.2197 18.6357 14.2197C19.7432 14.2197 20.6924 13.2705 20.6924 12.1631Z"
  })));
};

Ellipsis.displayName = 'Ellipsis';
export default Ellipsis;